import React from 'react';

import { Container, Left, Right, Title, Subtitle, CloseButton, CloseIcon } from './styles';

interface Props {
  title?: string;
  subtitle?: string | JSX.Element;
  onClose?: () => void;
  highlight?: boolean;
}

const ModalHeader = ({ title, subtitle, onClose, highlight }: Props) => (
  <Container className={highlight ? 'highlight' : ''}>
    <Left>
      <Title $subtitle={subtitle ? true : false}>{title}</Title>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </Left>
    {onClose && (
      <Right>
        <CloseButton onClick={onClose}>
          <CloseIcon />
        </CloseButton>
      </Right>
    )}
  </Container>
);

export default ModalHeader;
